import { useSelector } from 'react-redux';
import { formatAmount, formatPrice } from '../../../../helpers/format';
import { selectDesiredCreditsAmount } from '../../../../store/account/selectors';
import {
  StyledContainer,
  StyledPaper,
  StyledPaperLabel,
  StyledPaperValue,
  StyledRow,
  StyledTotalPricePaper,
  StyledTotalPricePaperValue,
} from './styled';

type Props = {
  pricePerCredit: number;
  labels: {
    totalUnits: string;
    costPerUnit: string;
    total: string;
  };
};

const CreditsPrice = ({ pricePerCredit, labels }: Props) => {
  const amount = useSelector(selectDesiredCreditsAmount);
  const totalPrice = formatPrice(pricePerCredit * amount);

  return (
    <StyledContainer>
      <StyledRow>
        <StyledPaper>
          <StyledPaperLabel>{labels.totalUnits}</StyledPaperLabel>
          <StyledPaperValue>{formatAmount(amount)}</StyledPaperValue>
        </StyledPaper>
        <StyledPaper>
          <StyledPaperLabel>{labels.costPerUnit}</StyledPaperLabel>
          <StyledPaperValue>{formatPrice(pricePerCredit)}</StyledPaperValue>
        </StyledPaper>
      </StyledRow>
      <StyledTotalPricePaper>
        <StyledPaperLabel>{labels.total}</StyledPaperLabel>
        <StyledTotalPricePaperValue>{totalPrice}</StyledTotalPricePaperValue>
      </StyledTotalPricePaper>
    </StyledContainer>
  );
};

export default CreditsPrice;
